import React, { useState } from 'react'

import useDeepEqualsMemoValue from 'v2/ui/utils/useDeepEqualsMemoValue'

import { ToolbarContext, ToolbarContextValue } from './hooks/useToolbarContext'

type ToolbarContextProviderProps = Pick<
    ToolbarContextValue,
    | 'objectSid'
    | 'searchQuery'
    | 'onChangeSearchQuery'
    | 'addNewEmptyRecord'
    | 'recordsSelectedCount'
    | 'deleteRecordsSelected'
    | 'onFieldCreated'
    | 'records'
    | 'isTrashMode'
    | 'setIsTrashMode'
    | 'restoreRecordsSelected'
    | 'dataConnection'
> & {
    children: React.ReactNode
}

export const ToolbarContextProvider: React.FC<ToolbarContextProviderProps> = ({
    children,
    ...props
}) => {
    const [isFiltersPaneOpen, setIsFiltersPaneOpen] = useState(false)

    const value = useDeepEqualsMemoValue({
        ...props,
        isFiltersPaneOpen,
        setIsFiltersPaneOpen,
    })

    return <ToolbarContext.Provider value={value}>{children}</ToolbarContext.Provider>
}
